
var content = require("!!../../../../../../../node_modules/css-loader/index.js??ref--9-1!../../../../../../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../../../../../node_modules/postcss-loader/src/index.js??ref--9-2!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./SettingsIcon.vue?vue&type=style&index=0&id=690d8722&scoped=true&lang=css&");

if(typeof content === 'string') content = [[module.id, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = require("!../../../../../../../node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(module.hot) {
	module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js??ref--9-1!../../../../../../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../../../../../node_modules/postcss-loader/src/index.js??ref--9-2!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./SettingsIcon.vue?vue&type=style&index=0&id=690d8722&scoped=true&lang=css&", function() {
		var newContent = require("!!../../../../../../../node_modules/css-loader/index.js??ref--9-1!../../../../../../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../../../../../node_modules/postcss-loader/src/index.js??ref--9-2!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./SettingsIcon.vue?vue&type=style&index=0&id=690d8722&scoped=true&lang=css&");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}